import React from "react";
import "./css/cube.css";

const Cube = React.forwardRef(({ cubeClass }, ref) => (
  <div className={`cube ${cubeClass}`} ref={ref}>
    <div className="face front">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 48 48"
        fill="none"
      >
        <path fill="#000" d="M0 0h48v48H0z" />
        <path
          fill="#CDE052"
          d="M14.819 43.169c-5.884 0-9.29-2.38-9.29-6.451l-.62-21.81c0-6.143 3.018-9.83 7.123-9.83l23.535 1.23c4.105 0 7.432.92 7.432 6.143v21.81c0 6.757-3.327 8.908-7.432 8.908H14.819Z"
        />
        <path
          fill="#000"
          d="M23.954 19.07a5.053 5.053 0 1 1 0 10.106 5.053 5.053 0 0 1 0-10.105Z"
        />
        <path
          fill="#000"
          d="M7.241 9.743c2.044-5.75 17.102-2.332 16.713-1.555-.388.777-9.717-2.332-12.826 1.555-4.444 5.555-3.951 20.924 1.166 26.04 1.753 1.754 7.385 4.525 12.438 4.665 5.052.14 10.105-1.04 12.826-2.332 2.72-1.292 1.554-7.774 2.72-6.996 1.166.777 1.944 8.55-1.554 10.105-3.498 1.555-7.385.389-16.713.654-9.328.265-12.438-.288-13.89-2.285-1.057-1.453-2.046-15.86-2.046-20.135 0-2.72.505-7.854 1.166-9.716ZM37.237 12.514c-1.395-2.22-.65-1.664-2.791-3.885-.794-.833-1.484-1.483-2.233-1.11-1.117.555 7.816 10.269 8.374 9.991.559-.277-1.954-2.775-3.35-4.996ZM38.368 17.556c-2.752-2.64-5.531-6.599-8.169-9.238-.978-.99-2.517-1.103-3.44-.66-1.376.66 14.617 14.847 15.306 14.517.688-.33-.945-1.98-3.697-4.62Z"
        />
      </svg>
    </div>
    <div className="face back">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 48 48"
        fill="none"
      >
        <path fill="#000" d="M0 0h48v48H0z" />
        <path
          fill="#CDE052"
          d="M4.74 14.988c0-5.884 2.38-9.29 6.45-9.29L33 5.078c6.144 0 9.83 3.018 9.83 7.123L41.6 35.736c0 4.105-.921 7.433-6.143 7.433h-21.81c-6.758 0-8.908-3.328-8.908-7.433V14.988Z"
        />
        <path
          fill="#000"
          d="M21.804 24.124a4.275 4.275 0 1 1-8.551 0 4.275 4.275 0 0 1 8.55 0Z"
        />
        <circle cx="30.743" cy="24.124" r="4.275" fill="#000" />
        <path
          fill="#000"
          d="M18.979 40.671c-.626 1.564-8.515 3.441-11.018 0-2.502-3.441-1.93-24.71-.538-27.041 1.391-2.332-1.818 20.374 2.332 24.524 4.15 4.15 9.85.953 9.224 2.517ZM28.06 7.8c.57-1.423 9.774-1.575 12.05 1.554 2.274 3.129.161 20.777-.778 20.21-.94-.566 1.962-15.915-1.166-19.044C35.037 7.391 27.492 9.221 28.06 7.8Z"
        />
        <path
          fill="#000"
          d="M33.062 11.297c.726-.97 3.683-1.092 4.782 1.766 1.099 2.858.602 6.633 0 6.008-.602-.626.79-2.061-.962-5.094-1.75-3.033-4.546-1.71-3.82-2.68Z"
        />
      </svg>
    </div>
    <div className="face left">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 48 48"
        fill="none"
      >
        <path fill="#000" d="M0 0h48v48H0z" />
        <path
          fill="#CDE052"
          d="M14.65 43.169c-5.884 0-9.29-2.38-9.29-6.451l-.62-21.81c0-6.143 3.018-9.83 7.123-9.83l23.535 1.23c4.104 0 7.432.92 7.432 6.143v21.81c0 6.757-3.328 8.908-7.432 8.908H14.65Z"
        />
        <path
          fill="#000"
          d="M31.558 26.844a4.275 4.275 0 1 1 0 8.551 4.275 4.275 0 0 1 0-8.55ZM23.785 19.848a4.275 4.275 0 1 1 0 8.55 4.275 4.275 0 0 1 0-8.55Z"
        />
        <circle
          cx="16.012"
          cy="17.166"
          r="4.275"
          fill="#000"
          transform="rotate(-90 16.012 17.166)"
        />
        <path
          fill="#000"
          d="M39.245 40.358c1.238 2.37 3.112-4.344 2.766-13.823-.346-9.478-1.037-3.95-1.037 1.58 0 5.529-2.966 9.873-1.729 12.243ZM20 41.149c-.569 1.422-9.773 1.574-12.049-1.555-1.056-1.452-2.045-15.859-2.045-20.134 0-2.721.504-7.855 1.166-9.717 2.043-5.75 17.102-2.332 16.713-1.555-.389.777-10.78-2.332-13.89 1.555-3.11 3.887-2.434 8.94-2.434 14.38 0 5.442 2.159 13.043 3.498 14.382 3.129 3.128 9.61 1.222 9.041 2.644Z"
        />
      </svg>
    </div>
    <div className="face right">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 48 48"
        fill="none"
      >
        <path fill="#000" d="M0 0h48v48H0z" />
        <path
          fill="#CDE052"
          d="M4.91 14.988c0-5.884 2.379-9.29 6.45-9.29l21.81-.62c6.143 0 9.83 3.018 9.83 7.123l-1.23 23.535c0 4.105-.921 7.433-6.143 7.433h-21.81c-6.757 0-8.908-3.328-8.908-7.433V14.988Z"
        />
        <path
          fill="#000"
          d="M22.01 30.342a4.275 4.275 0 1 1-8.55 0 4.275 4.275 0 0 1 8.55 0ZM22.01 18.682a4.275 4.275 0 1 1-8.55 0 4.275 4.275 0 0 1 8.55 0Z"
        />
        <circle cx="29.395" cy="30.342" r="4.275" fill="#000" />
        <circle cx="29.395" cy="18.682" r="4.275" fill="#000" />
        <path
          fill="#000"
          d="M19.148 40.67c-.625 1.565-8.515 3.442-11.017 0-2.503-3.44-2.28-17.713-.89-20.045 1.392-2.331-1.466 13.379 2.683 17.529 4.15 4.15 9.85.953 9.224 2.517ZM28.23 7.8c.568-1.423 9.773-1.575 12.048 1.554 2.276 3.129.163 20.777-.777 20.21-.94-.566 1.963-15.915-1.166-19.044C35.206 7.391 27.661 9.221 28.23 7.8Z"
        />
      </svg>
    </div>
    <div className="face top">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 48 48"
        fill="none"
      >
        <path fill="#000" d="M0 0h48v48H0z" />
        <path
          fill="#CDE052"
          d="M14.988 43.169c-5.884 0-9.29-2.38-9.29-6.451l-.62-21.81c0-6.143 3.018-9.83 7.123-9.83l23.535 1.23c4.105 0 7.432.92 7.432 6.143v21.81c0 6.757-3.327 8.908-7.432 8.908H14.988Z"
        />
        <path
          fill="#000"
          d="M24.124 19.848a4.275 4.275 0 1 1 0 8.551 4.275 4.275 0 0 1 0-8.55ZM16.35 12.852a4.275 4.275 0 1 1 0 8.55 4.275 4.275 0 0 1 0-8.55ZM16.35 27.622a4.275 4.275 0 1 1 0 8.55 4.275 4.275 0 0 1 0-8.55ZM31.897 27.622a4.275 4.275 0 1 1 0 8.55 4.275 4.275 0 0 1 0-8.55ZM31.897 12.852a4.275 4.275 0 1 1 0 8.55 4.275 4.275 0 0 1 0-8.55Z"
        />
        <path
          fill="#000"
          d="M38.505 40.836c-3.11 2.333-15.936.39-15.547-.388.388-.778 11.66 1.554 14.77-2.332 4.443-5.556 4.339-22.43-.778-27.547-1.753-1.752-7.956-2.192-13.008-2.332-5.053-.14-10.106 1.04-12.826 2.332-2.721 1.292-1.555 7.774-2.721 6.996-1.166-.777-1.943-8.55 1.555-10.105 3.498-1.555 7.384-.389 16.713-.654 9.328-.265 12.438.288 13.89 2.285 1.056 1.453 2.045 15.86 2.045 20.135 0 5.003-.984 9.278-4.093 11.61ZM13.197 40.642c-.84 1.123-4.262 1.264-5.533-2.043-1.271-3.307-.697-7.674 0-6.95.697.724-.913 2.384 1.113 5.893s5.26 1.977 4.42 3.1Z"
        />
      </svg>
    </div>
    <div className="face bottom">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 48 48"
        fill="none"
      >
        <path fill="#000" d="M0 0h48v48H0z" />
        <path
          fill="#CDE052"
          d="M5.079 14.988c0-5.884 2.379-9.29 6.45-9.29l21.81-.62c6.143 0 9.83 3.018 9.83 7.123l-1.23 23.535c0 4.105-.92 7.433-6.143 7.433h-21.81c-6.757 0-8.907-3.328-8.907-7.433V14.988Z"
        />
        <path
          fill="#000"
          d="M28.399 29.565a4.275 4.275 0 1 1-8.551 0 4.275 4.275 0 0 1 8.55 0ZM19.07 29.565a4.275 4.275 0 1 1-8.55 0 4.275 4.275 0 0 1 8.55 0ZM28.399 18.682a4.275 4.275 0 1 1-8.551 0 4.275 4.275 0 0 1 8.55 0ZM19.07 18.682a4.275 4.275 0 1 1-8.55 0 4.275 4.275 0 0 1 8.55 0Z"
        />
        <circle cx="33.452" cy="29.565" r="4.275" fill="#000" />
        <circle cx="33.452" cy="18.682" r="4.275" fill="#000" />
        <path
          fill="#000"
          d="M36.95 38.893c-.626 1.564-26.148 5.22-28.65 1.778-2.503-3.441-2.28-17.713-.89-20.045 1.392-2.332-.651 14.117 3.499 18.267 4.15 4.15 26.666-1.564 26.04 0ZM12.19 10.042c-2.418 1.075-1.813.517-4.23 2.137-.907.6-1.615 1.122-1.21 1.66.605.804 11.181-5.968 10.88-6.37-.303-.402-3.023 1.497-5.44 2.573ZM16.031 11.988c3.48-1.38 2.592-.626 6.104-2.777 1.316-.798 2.348-1.493 1.806-2.279-.809-1.17-16.153 7.794-15.749 8.38.404.585 4.359-1.943 7.84-3.324Z"
        />
      </svg>
    </div>
  </div>
));

export default Cube;
